export const maxPhoneScreen = '767px'
export const minTabletScreen = '768px'
export const maxTabletScreen = '1023px'
export const minDesktopScreen = '1024px'

export const isPhoneScreen = () =>
  window.matchMedia('(max-width: 767px)').matches

export const isTabletScreen = () =>
  window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches

export const isDesktopScreen = () =>
  window.matchMedia('(min-width: 1024px)').matches
